import { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';
import Step from './Step'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleUp, faHome } from "@fortawesome/free-solid-svg-icons";
import SourcedFrom from './SourcedFrom';
import ProductInfo from './ProductInfo';
import Sustainibility from './Sustainibility';
import Certifications from './Certifications';
import Story from './Story';
import Card from "./Card";
import { calculateMaterialsDowntheLine, calculatePartnersDowntheLine } from "./utility/utils";

function App() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const identifier = window.location.pathname.split('/')[1] ? window.location.pathname.split('/')[1]:''
  const [ productRoute, setProductRoute ] = useState(null)
  const [ error, setError ] = useState(null)
  const [ loading, setLoading ] = useState(false)
  const [visible, setVisible] = useState(false);
  const [path, setPath] = useState([]);


  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setLoading(true)
    const headers = {
      
    };
    console.log(process.env.REACT_APP_API_URL)
    try {
      axios
        .get(
          `${process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "https://api-dev.afts.biz/consumerApp/"}productRoute/${identifier}`,
          { headers }
        )
        .then((response) => {
          const { status, data } = response;
          if (status === 200 && data.id) {
            setProductRoute(data);
            setPath([data?.refProcessSteps[0]])
          }
          setLoading(false);
        })
        .catch((error) => {
          setError(error.toString());
          setLoading(false);
        });
    } catch (err) {
      setError(error.toString());
      setLoading(false);
    }
    //eslint-disable-next-line
  }, [identifier])

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  const onBreadcrumbClick = (index) => {
    setPath(path.slice(0, index + 1));
  };

  const onItemClick = (item) => {
    setPath([...path, item]);
  };

  if(error){
    return <div className="App d-flex justify-content-center align-items-start vh-100">
      <div className="alert alert-danger mt-5" role="alert">
        <h4 className="alert-heading">Ooops!</h4>
        <hr/>
        <p className="mb-0">{error}</p>
      </div>
    </div>
  }

  if(loading || productRoute===null){
    return <div className="App d-flex justify-content-center align-items-center vh-100">
      <div className="spinner-border text-success spinner" role="status">
        
      </div>
    </div>
  }

  const renderHeader = () => {
    if(productRoute!==null && productRoute.id)
    return <nav className="navbar rounded justify-content-center customShadow customRadius p-2 py-3">
        <img src={productRoute?.primary_logo} alt={productRoute.name} style={{height:'50px'}} />
    </nav>
  }

  const renderName = () => {
    if(productRoute!==null && productRoute.id)
    return <div className="d-flex align-items-center justify-content-center py-4">
        <h1 className='mainHeading'>{productRoute.name}</h1>
    </div>
  }

  const renderProductImage = () => {
    return <div className="card mt-0 customShadow customRadius" >
      <div className="card-body">
        <img className="card-img-top" src={productRoute.refImage} alt={productRoute.name} />
      </div>
    </div>
  }

  const renderProductInfo = () => {
    return <div className=" mt-3 productInfo text-center" >
      
      <p className="productDescription">{productRoute?.refSub_line && productRoute?.refSub_line.map((o,i) => o.name)}</p>
     
    </div>
  }

  /*
  const renderMaterials = () => {

    let materials =[]
    let html = []
    
    productRoute.refProcessSteps.map((o) => { 
      
      o.refMaterialsOut.map(material => {
        if(material.status === true ) materials.push(material)
        return material

      });
      
      return o
    })
    

    html = materials.map((material,i) => <li key={i} className="media d-inline-flex w-100 bg-white customShadow customRadius mb-2">
      <img className="m-3 materialImage" src={material.refImage} alt={material.refImage}  />
      <div className="media-body">
        <h5 className="mt-2 mb-1">{material.name}</h5>
        <p className="text-secondary">{material.description}</p>
      </div>
    </li>);

    return <div className="step" >
        <div className="stepCount">
            <div className="stepCountInner">
              
            </div>
        </div>
        <div className={`stepHeader mb-4`} onClick={() => setOpen(!open)}>
            
            <h4>Materials</h4>
            {open ?  <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown}/> }
        </div>
        
        {open ? <div className="stepContent">
          
          <ul className="list-unstyled ">{html}</ul>
        </div>:null}
    </div>

  }
  */

  const renderSteps = (step) => {
    let steps = productRoute?.refProcessSteps.filter((o) =>
      o.end.includes(step.id)
    );

    return steps.map((step, i) => (
      <Step
        key={step.id}
        step={step}
        no={i + 1}
        loadMore={(selected) => onItemClick(selected)}
        steps={productRoute.refProcessSteps}
      />
    ));
  };

  const renderFooter = () => {
    const date = new Date()
    return <footer className="d-flex justify-content-between mt-5 clear-both" >
      <div>
        <img height="60px" src={require('./assets/AFTSLogo-footer.png').default} alt="AFTS" />
      </div>
      <div className="copyright text-right">
          <h2>COPYRIGHT © {date.getFullYear()}</h2>
          <h1>AFTS</h1>
      </div>
    </footer>
  }

  const renderGotoTop = () => {

    const onTrigger = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return scrollPosition > window.innerHeight ? <div className="gotTo" onClick={onTrigger} >
      <FontAwesomeIcon icon={faAngleDoubleUp} />
    </div>  : null
  }

  const renderBreadcrumb = () => {

    const rootStep = productRoute.refProcessSteps[0];

    return path.length > 1 && (
      <div className="customRadius breadcrumb d-flex flex-row align-items-center justify-content-start py-2 px-2">
        <FontAwesomeIcon icon={faHome} onClick={() => onBreadcrumbClick(0)} />
        {path.map((item, index) => (
          <div  onClick={() => onBreadcrumbClick(index)} key={item.id} style={{ padding: "8px" }}>
            <span className={index == path.length-1 && 'p-1 customRadius badge-success'}>
              {item.refMaterialsOut[0]?.name} {index < path.length - 1 && ">"}
              </span>
          </div>
        ))}
      </div>
    );
  };

  const getMaterialsCount = () => {
    let currentStep = 0;

    if(path.length <=0 ) currentStep = productRoute.refProcessSteps[0];
    else currentStep = path[path.length-1];

    return calculateMaterialsDowntheLine(currentStep.id, productRoute.refProcessSteps)
  }

  const getPartnersCount = () => {
    let currentStep = 0;

    if(path.length <=0 ) currentStep = productRoute.refProcessSteps[0];
    else currentStep = path[path.length-1];
    
    return calculatePartnersDowntheLine(currentStep.id, productRoute.refProcessSteps);
  }

  const getCurrentCardName = () => {
    
    return path.length <=0 ? productRoute.name : path[path.length-1].refMaterialsOut[0]?.name;
  }


  return (<>
    <div className="App m-2 p-2 ">
      {renderHeader()}
      {renderName()}
      {renderProductImage()}
      {renderProductInfo()}
      <SourcedFrom route={productRoute} />
      <div className='mt-3 mb-5 row'>
        <div className='col-6'>
          <ProductInfo route={productRoute} />
        </div>
        <div className='col-6'>
          <Sustainibility  route={productRoute} />
        </div>
        <div className='col-6 mt-3'>
          <Certifications route={productRoute}  />
        </div>
        <div className='col-6 mt-3'>
          <Story route={productRoute}  />
        </div>
      </div>
      {renderBreadcrumb()}
      <Card
        materialsCount={getMaterialsCount()}
        partnersCount={getPartnersCount()}
        name={getCurrentCardName()}
      />
      <div className="stepsWrapper">
        <div className="allSteps">
        {renderSteps(path[path.length - 1])}
        </div>
      </div>
      {renderGotoTop()}
     
    </div>
    {renderFooter()}
  </>
  );
}

export default App;
